module.exports = __webpack_public_path__ + "static/media/ShowMoreText.a8db7393.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-show-more-text/lib/ShowMoreText.css
// module id = 1232
// module chunks = 0